import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@services/auth';

export const customerPortalGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const user = authService.getCurrentUser();

  if (user && authService.canAccessDashboard()) {
    return router.createUrlTree(['/admin/dashboard']);
  }

  if (user) {
    return true;
  }

  return authService.ensureDashboardSession().pipe(
    map((isDashboardUser) =>
      isDashboardUser ? router.createUrlTree(['/admin/dashboard']) : true,
    ),
  );
};
